<h2 mat-dialog-title>Re-authentication</h2>
<mat-dialog-content>
    Your session has expired. Please continue by re-authenticating.
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()">Log in</button>
</mat-dialog-actions>
